"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageBubble = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsIcons = require("@olxbr/ds-icons");
var _UserTyping = require("../../atoms/UserTyping");
var _util = require("./util");
var _styles = require("./styles");
var _textProcessing = require("../../../helpers/textProcessing");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var MessageBubble = exports.MessageBubble = function MessageBubble(_ref) {
  var text = _ref.text,
    time = _ref.time,
    isMine = _ref.isMine,
    status = _ref.status,
    isTyping = _ref.isTyping,
    isEmoji = _ref.isEmoji,
    numberEmoji = _ref.numberEmoji,
    masks = _ref.masks,
    idMessage = _ref.idMessage;
  var MessageContent = function MessageContent() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextArea, {
        isEmoji: isEmoji,
        numberEmoji: numberEmoji,
        children: isMine ? (0, _textProcessing.urlify)(text) : (0, _util.formatText)(idMessage, text, masks, _textProcessing.urlify)
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Statuarea, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TimeArea, {
          children: time
        }), isMine && /*#__PURE__*/(0, _jsxRuntime.jsx)(IconArea, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Check2Small, {
            size: 16
          })
        })]
      })]
    });
  };
  var Wrapper = isMine ? _styles.SentWrapper : _styles.ReceivedWrapper;
  var Content = isTyping ? _UserTyping.UserTyping : MessageContent;
  var IconArea = status === 'read' ? _styles.IconAreaRead : _styles.IconAreaSent;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
    isEmoji: isEmoji,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {})
  });
};